<div class="skh" aria-hidden="true">

  <!-- Hero: copy block left, media block right (no label/heading bar) -->
  @if (spec.layout === 'hero') {
    <div class="skh-hero">
      <div class="skh-hero-copy">
        <div class="skh-row"><span class="sk sk-line-lg" style="width:190px"></span><span class="sk sk-line-lg" style="width:120px"></span></div>
        <div class="skh-row"><span class="sk sk-line-lg" style="width:130px"></span><span class="sk sk-line-lg" style="width:150px"></span></div>
        <span class="sk sk-line skh-mb"></span>
        <span class="sk sk-line skh-mb" style="width:88%"></span>
        <span class="sk sk-line skh-mb" style="width:72%"></span>
        <div class="skh-row">
          <span class="sk sk-chip" style="width:130px;height:40px"></span>
          <span class="sk sk-chip" style="width:130px;height:40px"></span>
        </div>
      </div>
      <span class="sk skh-hero-media"></span>
    </div>
  }

  <!-- Our Story: left-aligned copy (eyebrow, 2 heading lines, 3 body lines, CTA)
       beside the 720x460 video block -->
  @if (spec.layout === 'story') {
    <div class="skh-story">
      <div class="skh-story-copy">
        <span class="sk sk-line-sm skh-mb" style="width:190px"></span>
        <div class="skh-row"><span class="sk sk-line-lg" style="width:210px"></span><span class="sk sk-line-lg" style="width:120px"></span></div>
        <div class="skh-row"><span class="sk sk-line-lg" style="width:150px"></span></div>
        <span class="sk sk-line skh-mb"></span>
        <span class="sk sk-line skh-mb" style="width:92%"></span>
        <span class="sk sk-line skh-mb" style="width:64%"></span>
        <span class="sk sk-chip skh-mt" style="width:150px;height:22px"></span>
      </div>
      <span class="sk skh-story-media"></span>
    </div>
  }

  <!-- Everything else opens with the label chip + wide heading bar -->
  @if (spec.layout !== 'hero' && spec.layout !== 'story') {
    <div class="skh-head" [class.skh-head--centred]="spec.centred">
      <div class="skh-row skh-label-row">
        <span class="sk sk-line-sm" style="width:74px"></span>
        <span class="sk sk-line-sm" style="width:62px"></span>
      </div>
      <span class="sk skh-heading"></span>
    </div>
  }

  <!-- Card grid: Why Choose / Categories / Featured / Modify / Testimonials / Recent -->
  @if (spec.layout === 'cards') {
    <div class="skh-grid" [style.--cols]="spec.cols">
      @for (i of blocks; track i) {
        <span class="sk sk-block" [style.height.px]="spec.h"></span>
      }
    </div>
  }

  <!-- How It Works: numbered circles with a label under each -->
  @if (spec.layout === 'steps') {
    <div class="skh-steps">
      @for (i of blocks; track i) {
        <div class="skh-step">
          <span class="sk sk-circle skh-step-circle"></span>
          <div class="skh-row skh-step-label">
            <span class="sk sk-line-sm" style="width:44px"></span>
            <span class="sk sk-line-sm" style="width:36px"></span>
          </div>
        </div>
      }
    </div>
  }

  <!-- Logo strip: Brands marquee / Companies wall -->
  @if (spec.layout === 'strip') {
    <div class="skh-strip">
      @for (i of blocks; track i) {
        <div class="skh-row skh-strip-item">
          <span class="sk sk-line" style="width:38px"></span>
          <span class="sk sk-line" style="width:32px"></span>
        </div>
      }
    </div>
    <div class="skh-strip">
      @for (i of blocks; track i) {
        <div class="skh-row skh-strip-item">
          <span class="sk sk-line" style="width:38px"></span>
          <span class="sk sk-line" style="width:32px"></span>
        </div>
      }
    </div>
  }

  <!-- S&F in Numbers: four stat blocks -->
  @if (spec.layout === 'stats') {
    <div class="skh-grid" style="--cols:4">
      @for (i of blocks; track i) {
        <div class="skh-stat">
          <span class="sk sk-line-lg" style="width:110px"></span>
          <span class="sk sk-line" style="width:80px"></span>
          <span class="sk sk-line-sm" style="width:100%"></span>
          <span class="sk sk-line-sm" style="width:70%"></span>
        </div>
      }
    </div>
  }

  <!-- Insights: big featured card beside a stacked list -->
  @if (spec.layout === 'split') {
    <div class="skh-split">
      <div class="skh-split-main">
        <span class="sk sk-block" [style.height.px]="spec.h"></span>
        <div class="skh-row skh-mt"><span class="sk sk-line" style="width:70px"></span><span class="sk sk-line" style="width:90px"></span></div>
        <span class="sk sk-line skh-mb" style="width:80%"></span>
        <span class="sk sk-line-sm skh-mb"></span>
      </div>
      <div class="skh-split-list">
        @for (i of r4; track i) {
          <div class="skh-split-item">
            <span class="sk skh-split-thumb"></span>
            <div class="skh-split-copy">
              <div class="skh-row"><span class="sk sk-line" style="width:60px"></span><span class="sk sk-line" style="width:52px"></span></div>
              <span class="sk sk-line-sm" style="width:90%"></span>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- FAQ: stacked full-width rows -->
  @if (spec.layout === 'rows') {
    <div class="skh-rows">
      @for (i of blocks; track i) {
        <span class="sk sk-block" [style.height.px]="spec.h"></span>
      }
    </div>
  }

  @if (spec.cta) {
    <div class="skh-cta">
      <span class="sk sk-chip" style="width:76px;height:38px"></span>
      <span class="sk sk-chip" style="width:76px;height:38px"></span>
    </div>
  }
</div>
